// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

/* istanbul ignore next  */
mock.onGet('/apps/discounts/getData').reply(config => {
    // eslint-disable-next-line object-curly-newline
    let data = [
        {
            id: 1,
            week: "1a semana",
            import: 4200,
            discount: 10
        },
        {
            id: 2,
            week: "2a semana",
            import: 4200,
            discount: 12
        },
        {
            id: 3,
            week: "3a semana",
            import: 4200,
            discount: 14
        },
        {
            id: 4,
            week: "4a y 5a semana",
            import: 4200,
            discount: 16
        }
    ]
    return [
        200,
        {
            data: data
        }
    ]
})

export const getData = createAsyncThunk('discounts/getData', async params => {
    let result = await axios.get('/apps/discounts/getData')
    return {
        params,
        data: result.data.data,
        total: result.data.data.length
    }
})

export const updateDiscount = createAsyncThunk('discounts/updateDiscount', async (discount, { dispatch, getState }) => {
    let result = await axios.post('/apps/discounts/update-discount', discount)
    // await dispatch(getData(getState().discounts.params))
    // let result = false
    return result
})

export const discountsSlice = createSlice({
    name: 'discounts',
    initialState: {
        params: {},
        data: [],
        total: 1
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.total
            })
    }
})

export default discountsSlice.reducer
